/* eslint-disable @typescript-eslint/no-explicit-any */
import { cn } from "@/lib/utils";
import mixpanel from "mixpanel-browser";
import React from "react";
import { FaCheck } from "react-icons/fa6";

const StepperList = [
  {
    title: "Accept Opportunity",
    description: "Step details here",
    // icon: <MdCampaign />,
  },
  {
    title: "Share Draft",
    description: "Step details here",
    // icon: <FaIdCard />,
  },
  {
    title: "Get Approved",
    description: "Step details here",
    // icon: <PiNotepadFill />,
  },
  {
    title: "Go LIVE!",
    description: "Step details here",
    // icon: <BsFillClipboard2CheckFill />,
  },
];

export const StepperListStatus = ({
  bgClass,
  animateClass,
  icon,
}: {
  bgClass: string;
  animateClass: string;
  icon: React.ReactNode;
}) => {
  return (
    <>
      <span
        className={cn(
          `flex items-center  justify-center w-[18px] h-[18px]  rounded-full   -start-4 ring-1 ring-[#DC2627] dark:ring-gray-900 dark:bg-green-900`,
          bgClass,
          animateClass
        )}
      >
        {icon}
      </span>
    </>
  );
};

export const StepperListItem = ({
  onClick,
  key,
  title,
  children,
  className,
}: {
  onClick: () => void;
  key: number;
  title: string;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <li
      key={key}
      onClick={onClick}
      className={cn(
        `text-sm font-medium hover:bg-[#381c1c] hover:text-[#FAFAFA] w-full py-[10px] px-[8px] rounded-md cursor-pointer flex items-center gap-3`,
        className
      )}
    >
      {children}
      <span className="">{title}</span>
    </li>
  );
};

export const BrandCollabStepper = ({
  collab,
  currentStep,
  setCurrentStep,
}: {
  collab: any;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
}) => {
  return (
    <div className="w-full flex flex-1 mt-12">
      <ol className="w-full flex flex-col items-start gap-3">
        {StepperList?.map((item, index) => (
          <StepperListItem
            key={index}
            className={` ${
              currentStep === index + 1
                ? "text-[#FAFAFA] bg-[#381c1c]"
                : "text-[#A6A6A6] bg-[#1C1C1C]"
            }`}
            onClick={() => {
              mixpanel.track(
                `Influencer Brand Collab Details Sidebar : ${item?.title} - Clicked `
              );
              collab?.response === "accepted"
                ? collab?.brandApproval !== "accepted" && index === 3
                  ? ""
                  : setCurrentStep(index + 1)
                : "";
            }}
            title={item?.title}
            children={
              <StepperListStatus
                bgClass={`${
                  (collab?.response === "accepted" &&
                    index <= 1 &&
                    collab?.draftMessageLink?.length < 1) ||
                  (collab?.draftMessageLink?.length > 0 &&
                    collab?.brandApproval !== "accepted" &&
                    index < 3) ||
                  (collab?.response === "pending" && index === 0) ||
                  (collab?.brandApproval === "accepted" &&
                    !collab?.trackingLink &&
                    index <= 3) ||
                  collab?.trackingLink
                    ? "bg-[#DC2627]"
                    : "bg-transparent"
                } `}
                animateClass={`${
                  (collab?.response === "pending" && index === 0) ||
                  (collab?.response === "accepted" &&
                    index === 1 &&
                    collab?.draftMessageLink?.length < 1) ||
                  (collab?.draftMessageLink?.length > 0 &&
                    collab?.brandApproval !== "accepted" &&
                    index === 2) ||
                  (collab?.brandApproval === "accepted" &&
                    !collab?.trackingLink &&
                    index === 3)
                    ? "animate-pulse"
                    : ""
                }`}
                icon={
                  (collab?.response === "accepted" &&
                    index < 1 &&
                    collab?.draftMessageLink?.length < 1) ||
                  (collab?.draftMessageLink?.length > 0 &&
                    collab?.brandApproval !== "accepted" &&
                    index < 2) ||
                  (collab?.brandApproval === "accepted" &&
                    !collab?.trackingLink &&
                    index < 3) ||
                  collab?.trackingLink ? (
                    <FaCheck color="#000" />
                  ) : (
                    ""
                  )
                }
              />
            }
          />
        ))}
      </ol>
    </div>
  );
};
